// #region Imports

// --- Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// --- RxJs
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';
import { TranslateService } from '@ngx-translate/core';

// --- Hs Code
import { environment } from '../../../../environments/environment';
import { SurveyResponseModel, InvitationTypes, ApplicationError, ErrorMessage } from '../../../models';
import { AppService } from '../app.service';
import { InvitationBaseService } from './invitation-base.service';
import { ResponseBaseService } from './response-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class InvitationService extends InvitationBaseService {
  constructor(
    private appService: AppService,
    private httpClient: HttpClient,
    private responseService: ResponseBaseService,
    private translateService: TranslateService,
  ) {
    super();
  }

  sendInvitations(surveyResponseModel: SurveyResponseModel): void {
    if (!surveyResponseModel) {
      return;
    }

    const url = environment.apiConfig.surveyApiUrl + environment.apiConfig.invitationsApi;
    const model = {
      participantId: surveyResponseModel.id,
      invitationType: InvitationTypes.respondentReminder
    };

    this.appService.setLoading(true);

    this.httpClient.post(url, model)
    .pipe(
      tap(() => this._invitationSuccess$.next(true)),
      retryBackoff(environment.retryConfig),
      catchError(this._invitationError.bind(this))
    )
    .subscribe(() => {
      this.appService.setLoading(false);
      if (this._invitationSuccess$.value) {
        this.responseService.updateStatus(surveyResponseModel);
      }
    });
  }

  private _invitationError(err: any): Observable<{}> {
    // ToDo: Put a friendly message here about invitations not being sent

    const error: ApplicationError = ApplicationError.create(
      ErrorMessage.genericErrorCode,
      'RespondentSurveyService',
      false,
      err
    );

    this.appService.setLastError(error);
    this._invitationSuccess$.next(false);
    return of({ success: false });
  }
}
